<template>
  <div class="bg-orange-academy-300 text-white p-4 rounded-3xl h-10 flex items-center
  font-sans-serif">
    {{ media.description }}
  </div>
</template>

<script>
export default {
  props: ['media'],
};
</script>
